import { render, staticRenderFns } from "./DonutChart67.vue?vue&type=template&id=023880dd&scoped=true"
import script from "./DonutChart67.vue?vue&type=script&lang=js"
export * from "./DonutChart67.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023880dd",
  null
  
)

export default component.exports